// import { hot } from 'react-hot-loader/root';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/system';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { connect } from 'react-redux';

import Notifier from './components/Notifier';
import { darkScrollbarStyles, lightScrollbarStyles } from './components/ScrollBar/ScrollBar';
import Home from './dashboard';
import { CustomErrorBoundary } from './dashboard/utils/Errors/ErrorBoundary';
import { appBackground, themeDark, themeLight } from './services';

if (process.env.REACT_APP_ENV === 'docker') {
    axios.defaults.baseURL = `${process.env.REACT_APP_DJANGO_URL}`;
} else {
    axios.defaults.baseURL = window.location.origin;
}
axios.defaults.withCredentials = true;

function App(props) {
    const { lightOn } = props;
    const theme = lightOn ? themeLight : themeDark;
    const scrollbarStyles = lightOn ? lightScrollbarStyles : darkScrollbarStyles;

    return (
        <CustomErrorBoundary name={'Global'}>
            <ThemeProvider theme={theme}>
                <GlobalStyles styles={scrollbarStyles} />
                {/* index.html hardcodes a dark anti-flash body colour inline;
                    inline styles beat stylesheet rules, so it would otherwise
                    stay dark in light mode and read as a darker rectangle behind
                    the sidebar in dark mode. Paint the body with the SAME fixed
                    gradient as the content area (!important to beat the inline
                    style) — any sliver revealed during the sidebar animation is
                    then seamless in both themes. */}
                <GlobalStyles
                    styles={{
                        body: {
                            background: `${appBackground(theme.palette.mode)} !important`,
                            backgroundAttachment: 'fixed',
                        },
                    }}
                />

                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <SnackbarProvider
                        maxSnack={3}
                        autoHideDuration={4000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        sx={{
                            '& .notistack-MuiContent': {
                                borderRadius: '10px',
                                fontSize: '0.8125rem',
                                fontWeight: 500,
                                boxShadow: lightOn ? '0 4px 20px rgba(0,0,0,0.10)' : '0 4px 20px rgba(0,0,0,0.40)',
                            },
                        }}
                    >
                        <Notifier />
                        <Home />
                    </SnackbarProvider>
                </LocalizationProvider>
            </ThemeProvider>
        </CustomErrorBoundary>
    );
}

const mapStateToProps = (state) => {
    return {
        lightOn: state.preference.lightOn,
    };
};

export default connect(mapStateToProps)(App);
